module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alert-message":"The most recent 20 items are displayed. You can check other items from the tray."},"ja":{"alert-message":"最も最近の20件が表示されています他の案件はトレイからご確認いただけます"}}')
  delete Component.options._Ctor
}
